function onlyNumbersValidator(value: unknown): boolean {
  return /^\d+$/.test(`${value}`);
}

export default onlyNumbersValidator;
